module.exports = __webpack_public_path__ + "20ccebdcce35af141e3d8db1dc8c036a.png";